import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { finalize, tap } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { SettingService } from '../../shared/services/setting.service';
import { ApiControllerService } from 'src/app/shared/services/api-controller.service';
interface itemBrand {
  id: string,
  merchantId: string, 
  name: any
}
@Injectable({
  providedIn: 'root'
})
export class ItemBrandServiceService {
  itemBrands: any;
  constructor(
    private http: HttpClient,
    private settingService: SettingService,
    private apiController: ApiControllerService) { }

  getBrands(id: string)
  {
      return Observable.create(o=>{
        /* this.http.post(this.settingService.apiUrl('ItemBrand/FindAllBrand'),{merchantId: id})
        .pipe(finalize(()=>{
          o.complete();
        }))
        .subscribe((res: itemBrand[])=>{
          o.next(res);
        }) */

        this.apiController.post(this.settingService.apiUrl('ItemBrand/FindAllBrand'),{merchantId: id})
        .pipe(finalize(()=>{
          o.complete();
        }))
        .subscribe((res: itemBrand[])=>{
          o.next(res);
        })
      })
  }
}
